module.exports = __webpack_public_path__ + "static/media/Fig-6-11_Retreat.d9ee81c2.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/content/media/Fig-6-11_Retreat.mp3
// module id = 786
// module chunks = 0